import { Close } from '@mui/icons-material';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { openNotification } from '../../../../helpers/notification';
import { makeFacilityPersonnelAdministrator } from '../../../../helpers/api';

export default function PersonnelInvite({ open, onClose, facilityId, personelInfo }) {
  const [saving, setSaving] = useState(false);

  const handleInvite = async () => {
    setSaving(true);
    try {
      const payload = {
        personnelId: personelInfo?.personelId,
      };
      const res = await makeFacilityPersonnelAdministrator(payload);
      console.log(res)
      const { data, status } = res?.result;
      if (status?.code === '00') {
        openNotification({
          type: 'success',
          message: status?.desc,
        });
        onClose();
      } else {
        openNotification({
          type: 'error',
          message: status?.desc,
        });
      }
    } catch (error) {
      console.log(error);
      openNotification({
        type: 'error',
        message: 'Something went wrong.',
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <DialogTitle variant="body1" sx={{ fontWeight: 600 }}>
          Make Admin
        </DialogTitle>
        <Box ml="auto" px={3}>
          <IconButton onClick={() => onClose()} disabled={saving}>
            <Close />
          </IconButton>
        </Box>
      </Box>
      <DialogContent sx={{}}>
        <Alert
          severity="info"
          icon={false}
        >{`You are about to make the Personnel an Administrator to your facility`}</Alert>
        <Typography mt={2} color="warning">{`An invite will be sent`}</Typography>
        <Typography
          mt={2}
        >{`This means the personnel will be able to login as a user and have access to required facility information/activities`}</Typography>
      </DialogContent>
      <DialogActions sx={{ px: 2, pb: 2 }}>
        <Button
          type="button"
          variant="contained"
          color="info"
          disabled={saving}
          startIcon={saving && <CircularProgress size={20} />}
          sx={{ textTransform: 'none', borderRadius: 20 }}
          onClick={handleInvite}
        >
          Yes, Make Admin
        </Button>
      </DialogActions>
    </Dialog>
  );
}
